import { createSelector } from 'redux-orm';

import orm from '../orm';

export const deviceModelsSelector = createSelector(orm, ({ DeviceModel, Attachment }) => {
  return DeviceModel.getOrderedQuerySet()
    .toRefArray()
    .map((deviceModel) => {
      let attachmentModel;
      if (deviceModel.coverAttachmentId) {
        attachmentModel = Attachment.withId(deviceModel.coverAttachmentId);
      }
      return {
        ...deviceModel,
        attachment: attachmentModel?.ref,
      };
    });
});

export const makeDeviceModelByIdSelector = () =>
  createSelector(
    orm,
    (_, id) => id,
    ({ DeviceModel, Attachment }, id) => {
      const modelModel = DeviceModel.withId(id);

      if (!modelModel) {
        return modelModel;
      }

      let attachmentModel;
      if (modelModel.coverAttachmentId) {
        attachmentModel = Attachment.withId(modelModel.coverAttachmentId);
      }

      return {
        ...modelModel.ref,
        attachmentModel,
      };
    },
  );

export const deviceModelByIdSelector = makeDeviceModelByIdSelector();
